import { updateUser } from 'actions/userActions';
import { USERS_API_FILTER_URL, USERS_API_URL, USERS_BULK_INSERT_SHEET_URL } from 'constants/ApiConstants';

import * as types from '../actionTypes';

export const getUsers = (params, meta = {}) => ({
  type: types.FETCH_USERS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: USERS_API_FILTER_URL,
      params: {
        sort: ['firstName,asc', 'lastName,asc'],
        ...params,
      },
    },
  },
  meta,
});

/**
 * @param {import('modules/global/generic.types').PageContent<import('../types/projections/user').User>} data
 * @param {Object} [meta={}]
 * @returns {import('modules/users/types/actions').GetUsersSuccessAction}
 */
export const getUsersSuccess = (data, meta = {}) => ({
  type: types.FETCH_USERS_SUCCESS,
  payload: data,
  meta,
});

export const getUsersFailure = (error, meta = {}) => ({
  type: types.FETCH_USERS_FAILURE,
  payload: error,
  error: true,
  meta,
});

/**
 * @param {string} userId
 * @param {keyof(import('modules/users/types/projections/detailed-user').DetailedUser)} field
 * @param {string} value
 * @param {Object} [meta={}]
 * @returns {import('modules/users/types/actions').PatchUserRequestAction}
 */
export const patchUser = (userId, field, value, meta = {}) => ({
  type: types.PATCH_USER,
  payload: {
    request: {
      method: 'PATCH',
      url: `${USERS_API_URL}/${userId}/${field}`,
      data: {
        [field]: value,
      },
    },
  },
  meta,
});

/**
 * @param {import('modules/users/types/projections/detailed-user').DetailedUser} user
 * @param {Object} [meta={}]
 * @returns {import('modules/users/types/actions').PatchUserSuccessAction}
 */
export const patchUserSuccess = (user, meta = {}) => ({
  type: types.PATCH_USER_SUCCESS,
  payload: user,
  meta,
});

/**
 *
 * @param {string} error
 * @param {Object} [meta={}]
 * @returns {import('modules/users/types/actions').PatchUserFailureAction}
 */
export const patchUserFailure = (error, meta = {}) => ({
  type: types.PATCH_USER_FAILURE,
  payload: error,
  error: true,
  meta,
});

/**
 *
 * @returns{import('modules/users/types/actions').DownloadUsersSheetRequestAction}
 */
export const downloadUsersSheet = () => ({
  type: types.DOWNLOAD_USER_SHEET_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: USERS_BULK_INSERT_SHEET_URL,
      responseType: 'base64',
    },
  },
});

export const checkUser = (user, meta) => ({
  ...updateUser({ user, dryRun: true }, meta),
  type: types.CHECK_USER_REQUEST,
});

export const checkUserFailure = (error, meta) => ({
  type: types.CHECK_USER_FAILURE,
  payload: error,
  error: true,
  meta,
});

export const checkUserSuccess = (payload, meta) => ({
  type: types.CHECK_USER_SUCCESS,
  payload,
  meta,
});

export const addUserWarning = (payload, meta = {}) => ({
  type: types.ADD_USER_WARNING,
  payload,
  meta
});

/**
 * @param {import('modules/users/types/actions').CheckPayload} payload
 * @returns {import('modules/users/types/actions').CheckAndUpdateAction}
 */
export const checkAndUpdate = (payload, meta = {}) => ({
  type: types.CHECK_AND_UPDATE,
  payload,
  meta,
});

/** @returns {import("modules/global/generic.types").Action<string>} */
export const approveChecksModal = (key, meta = {}) => ({
  type: types.CHECKS_MODAL_APPROVE,
  payload: key,
  meta,
});

/** @returns {import("modules/global/generic.types").Action<undefined>} */
export const rejectChecksModal = () => ({ type: types.CHECKS_MODAL_REJECT });

export const showPasswordModal = () => ({ type: types.SHOW_PASSWORD_MODAL });

export const hidePasswordModal = () => ({ type: types.HIDE_PASSWORD_MODAL });

export * from './dashboardCustomization';
